import { render } from "./pcView.vue?vue&type=template&id=3b2d643c&scoped=true"
import script from "./pcView.vue?vue&type=script&lang=js"
export * from "./pcView.vue?vue&type=script&lang=js"

import "./pcView.vue?vue&type=style&index=0&id=3b2d643c&scoped=true&lang=css"

import exportComponent from "/Users/yxgc/Desktop/DATA/res/WorldPress/beeNetPlugin/Bee_RewardPlugin/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2d643c"]])

export default __exports__